
import { Employee } from '@/types';
import { formatDate } from '@/lib/utils';

interface EmployeeInformationProps {
  employee?: Employee;
  displayName: string;
}

export const EmployeeInformation = ({ employee, displayName }: EmployeeInformationProps) => {
  return (
    <div className="p-6 border b border-gray-400 my-2 rounded-md">
      <h3 className="font-semibold text-lg mb-3">Employee Information</h3>
      <div className="grid grid-cols-4 gap-x-4 gap-y-2">
        <div>
          <p className="text-sm text-gray-500">Emp. Name</p>
          <p className="font-medium">{displayName}</p>
        </div>
        <div>
          <p className="text-sm text-gray-500">Dept.</p>
          <p className="font-medium">{employee?.department || 'N/A'}</p>
        </div>
        <div>
          <p className="text-sm text-gray-500">Job Title</p>
          <p className="font-medium">{employee?.jobTitle || 'N/A'}</p>
        </div>
        <div>
          <p className="text-sm text-gray-500">Social Security No.</p>
          <p className="font-medium">{employee?.socialSecurityNo || 'N/A'}</p>
        </div>
        
        <div>
          <p className="text-sm text-gray-500">NRC</p>
          <p className="font-medium">{employee?.nrc || 'N/A'}</p>
        </div>
        <div>
          <p className="text-sm text-gray-500">Man Number</p>
          <p className="font-medium">{employee?.manNumber || 'N/A'}</p>
        </div>
        <div>
          <p className="text-sm text-gray-500">Eng. Date</p>
          <p className="font-medium">{employee?.engagementDate ? formatDate(employee.engagementDate) : 'N/A'}</p>
        </div>
        <div>
          <p className="text-sm text-gray-500">Salary Scale</p>
          <p className="font-medium">{employee?.salaryScale || 'N/A'}</p>
        </div>
        
        <div>
          <p className="text-sm text-gray-500">Account No.</p>
          <p className="font-medium">{employee?.bankAccount || 'N/A'}</p>
        </div>
        <div>
          <p className="text-sm text-gray-500">Bank</p>
          <p className="font-medium">{employee?.bankName || 'N/A'}</p>
        </div>
        <div>
          <p className="text-sm text-gray-500">Bank Branch</p>
          <p className="font-medium">{employee?.bankBranch || 'N/A'}</p>
        </div>
        <div>
          <p className="text-sm text-gray-500">TPIN</p>
          <p className="font-medium">{employee?.taxId || 'N/A'}</p>
        </div>
        
        <div>
          <p className="text-sm text-gray-500">Cellphone</p>
          <p className="font-medium">{employee?.cellNumber || employee?.phone || 'N/A'}</p>
        </div>
        <div>
          <p className="text-sm text-gray-500">Email</p>
          <p className="font-medium">{employee?.email || 'N/A'}</p>
        </div>
        <div>
          <p className="text-sm text-gray-500">Gender</p>
          <p className="font-medium">{employee?.gender ? employee.gender.charAt(0).toUpperCase() + employee.gender.slice(1) : 'N/A'}</p>
        </div>
        <div>
          <p className="text-sm text-gray-500">Status</p>
          <p className="font-medium">{employee?.status ? employee.status.replace('_', ' ').charAt(0).toUpperCase() + employee.status.replace('_', ' ').slice(1) : 'N/A'}</p>
        </div>
      </div>
    </div>
  );
};
